import { Inject, Injectable } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';


@Injectable()
export class ScrollService {

  private readonly scroll$: Observable<Event> = fromEvent(this.window, 'scroll');

  constructor(@Inject('Window') private readonly window: Window) {}

  public observe(debounceTimer?: number): Observable<Event> {
    let scroll$ = this.scroll$;
    if (debounceTimer) {
      scroll$ = scroll$.pipe(debounceTime(debounceTimer));
    }
    return scroll$;
  }

}
